import React from "react";

export const NotificationNew = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#FFA869" />
      <g clipPath="url(#clip0_34647_2739)">
        <path
          d="M33.3393 16.2954L24.27 15.4542L20.6674 7.08873C20.4152 6.50297 19.5847 6.50297 19.3325 7.08873L15.7299 15.4543L6.66064 16.2954C6.02561 16.3543 5.76896 17.1441 6.24808 17.565L13.0909 23.5763L11.0883 32.4617C10.9481 33.0838 11.62 33.572 12.1684 33.2464L20 28.5961L27.8316 33.2464C28.38 33.572 29.0519 33.0838 28.9117 32.4617L26.9091 23.5763L33.7519 17.565C34.231 17.1441 33.9744 16.3543 33.3393 16.2954Z"
          fill="#FFDD72"
        />
        <path
          d="M20.6674 7.08873C20.4152 6.50297 19.5847 6.50297 19.3325 7.08873L15.7299 15.4543L6.66064 16.2954C6.02561 16.3543 5.76896 17.1441 6.24808 17.565L13.0909 23.5763L11.0883 32.4617C10.9481 33.0838 11.62 33.572 12.1684 33.2464L13.9163 32.2085C14.1583 22.2498 18.7854 15.2369 22.4488 11.2251L20.6674 7.08873Z"
          fill="#FFD54F"
        />
      </g>
      <defs>
        <clipPath id="clip0_34647_2739">
          <rect
            width="28"
            height="28"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
